import { Flex } from 'reflexbox/styled-components';
import styled from 'styled-components/macro';
import { color } from 'styled-system';

export const Wrapper = styled(Flex)`
    flex-direction: column;
    ${color};
    min-height: 100vh;
`;
